module.exports = __webpack_public_path__ + "img/icon_home.2518dbe.webp";